import BlogComponent from "../../components/BlogComponent"

export default BlogComponent



// WEBPACK FOOTER //
// ./src/pages/knowledgeresources/index.js